import type { PermissionSelector } from "@/hooks/usePermission";

export const canManageSurvey: PermissionSelector = (x) => x.surveys.canManage;
